import { FC } from 'react'
import { ProfileCard } from '@components-v2/molecules/ProfileCard'
import { InvestmentBase } from '@/types'
import { getCompanyLogo } from '@/utils'
import { useRouter } from 'next/router'

type Props = {
  investment: InvestmentBase
}

export const PortfolioCard: FC<Props> = ({ investment: inv }) => {
  const router = useRouter()
  return (
    <ProfileCard
      src={getCompanyLogo(inv.company)}
      title={inv.company.name}
      subtitle=''
      href={inv.company.status === 'published' ? `/${router.locale}/companies/${inv.company.slug}` : ''}
      size='small'
    />
  )
}
